import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Box,
    Typography,
    CircularProgress,
    Button,
    Paper,
} from '@mui/material';
import { useAuth } from '../hooks/useAuth';

const LoginPage: React.FC = () => {
    console.log('🔐 [LoginPage] RENDER');
    const navigate = useNavigate();
    const { login, isAuthenticated, isLoading } = useAuth();
    const [showLoginButton, setShowLoginButton] = useState(false);

    useEffect(() => {
        (window as any).showLogoutDebug = () => {
            const logs = JSON.parse(localStorage.getItem('logout_debug') || '[]');
            console.log('=== LOGOUT DEBUG LOGS ===');
            logs.forEach((log: any) => {
                console.log(`[${log.time}] ${log.message}`, log.data || '');
            });
            console.log('=== END DEBUG LOGS ===');
            return logs;
        };

        const logoutInProgress = sessionStorage.getItem('logout_in_progress');
        const logoutInitiated = sessionStorage.getItem('logout_initiated');

        if (logoutInProgress || logoutInitiated) {
            setShowLoginButton(true);
            setTimeout(() => {
                sessionStorage.removeItem('logout_in_progress');
                sessionStorage.removeItem('logout_initiated');
                sessionStorage.removeItem('logout_user_existed');
                sessionStorage.removeItem('logout_redirect_url');
                sessionStorage.removeItem('logout_error');
            }, 1000);
            return;
        }

        if (isAuthenticated) {
            navigate('/', { replace: true });
            return;
        }

        if (!isLoading && !isAuthenticated && !showLoginButton) {
            const performLogin = async () => {
                try {
                    await login('/');
                } catch (error) {
                    console.error('Failed to redirect to Keycloak:', error);
                    setShowLoginButton(true);
                }
            };

            const checkTimer = setTimeout(() => {
                const recentLogout = sessionStorage.getItem('logout_in_progress');
                const logoutInit = sessionStorage.getItem('logout_initiated');

                if (!recentLogout && !logoutInit) {
                    performLogin();
                } else {
                    setShowLoginButton(true);
                }
            }, 500);

            return () => clearTimeout(checkTimer);
        }
    }, [isAuthenticated, isLoading, navigate, login, showLoginButton]);

    const handleLoginClick = async () => {
        try {
            await login('/');
        } catch (error) {
            console.error('Failed to redirect to Keycloak:', error);
        }
    };

    return (
        <Box sx={{
            minHeight: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            bgcolor: 'background.default',
            px: 2,
        }}>
            <Paper elevation={0} sx={{
                maxWidth: 420,
                width: '100%',
                p: 6,
                borderRadius: 3,
                textAlign: 'center',
            }}>
                {showLoginButton ? (
                    <>
                        <Box sx={{ mb: 4 }}>
                            <img
                                src="/optima-uitzendburo.svg"
                                alt="Optima"
                                style={{ height: 48 }}
                            />
                        </Box>
                        <Typography variant="h5" fontWeight={600} gutterBottom>
                            Welcome back
                        </Typography>
                        <Typography variant="body2" color="text.secondary" sx={{ mb: 4 }}>
                            You have been logged out. Sign in to continue.
                        </Typography>
                        <Button
                            variant="contained"
                            size="large"
                            fullWidth
                            onClick={handleLoginClick}
                            sx={{ py: 1.5, borderRadius: 1.5 }}
                        >
                            Sign in with SSO
                        </Button>
                        <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 4 }}>
                            Optima Uitzendburo Admin
                        </Typography>
                    </>
                ) : (
                    <>
                        <CircularProgress size={48} sx={{ mb: 3 }} />
                        <Typography variant="body1" color="text.secondary">
                            Redirecting to login...
                        </Typography>
                    </>
                )}
            </Paper>
        </Box>
    );
};

export default LoginPage;
